import React, { useState } from "react";

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

// select
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Alert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';


import { useStyles } from './UserTheme';

// user adatok
import UserContext from "../../context/UserContext";

// form validation
import { useForm } from "react-hook-form";

// GET - POST - PUT
import useAxios from "../../request/useAxios";

export default function UserSettingOther() {
  const [alert, setAlert] = useState();
  const classes = useStyles();
  // user adatainak betöltése
  const user = React.useContext(UserContext);
  const { put } = useAxios();

  const { register, handleSubmit } = useForm();

  const handleChange = (event) => {
    user.settings.theme = event.target.value;
    user.settings.setUserTheme(event.target.value);
    // console.log("change ", event.target.value)
  };

  const handleChangeUserData = (e) => {
    let oldUser = { ...user };
    oldUser.user[e.target.name] = e.target.value;
    user.settings.setUser(oldUser);
  }

  const handleSubmitUserData = (d, e) => {
    const TS = JSON.parse(localStorage.getItem("TS"));
    // const data = JSON.stringify(x);
    put(
      `/salesman/update-profile`,
      user.user,
      {
        headers: {
          'Authorization': `Bearer ${TS.token}`,
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      }
    )
      .then((data) => {
        console.log('Put ok');
        setAlert(true);
      })
      .catch((error) => console.log("Could not send user data", error));
  }

  const handleClose = (event, reason) => {
    setAlert(false);
  };

  return <Grid container direction="row" className={classes.root}>
    <Grid item className={classes.formContanier}>
      <Snackbar open={alert} autoHideDuration={4000} onClose={handleClose}>
        <Alert className={classes.alert} variant="filled" severity="success">
          A változtatásokat elmentettük.
        </Alert>
      </Snackbar>
      <Typography align="center" variant="h6" gutterBottom>
        Regisztrációs adatok
        </Typography>
      <Divider />
      <form
        className={classes.form}
        onChange={handleChangeUserData}
        onSubmit={handleSubmit(handleSubmitUserData)}
        noValidate
      >
        {console.log(user)}
        <div>
          <TextField
            id="user-name"
            name="username"
            label="Felhasználónév"
            defaultValue={user.user.username}
            helperText=""
            variant="outlined"
            size="small"
            type="text"
            fullWidth
            inputRef={register()}
          />
        </div>
        <div>
          <TextField
            id="user-password"
            name="password"
            label="Jelszó"
            defaultValue={user.user.password}
            helperText=""
            variant="outlined"
            size="small"
            type="password"
            fullWidth
            inputRef={register()}
          />
        </div>
        <div>
          <TextField
            id="user-mail"
            name="email"
            label="E-mail"
            defaultValue={user.user.email}
            helperText=""
            variant="outlined"
            size="small"
            type="text"
            fullWidth
            inputRef={register()}
          />
        </div>
        <div>
          <FormControl
            fullWidth
            size="small"
            variant="outlined"
            className={classes.formControl}
          >
            <InputLabel id="demo-simple-select-outlined-label">Stílus</InputLabel>
            {/* {console.log('----', user.userTheme)} */}
            <Select
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              value={user.settings.theme}
              onChange={handleChange}
              label="Stílus"
            >
              <MenuItem value={'default'}>Default</MenuItem>
              <MenuItem value={'red'}>Piros</MenuItem>
              <MenuItem value={'narancs'}>Narancs</MenuItem>
              <MenuItem value={'blue'}>Kék</MenuItem>
              <MenuItem value={'green'}>Zöld</MenuItem>
            </Select>
          </FormControl>
        </div>
        <div className={classes.button}>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            type="submit"
          >
            Beküld
          </Button>
        </div>
      </form>
    </Grid>
    <Grid item xs>
      <Grid container className={classes.grund}>
      </Grid>
    </Grid>
  </Grid >;
}